import { useState } from "react";
import { useLayoutEffect, useMemo, useRef } from "react";
import { Color, EdgesGeometry, LineBasicMaterial, LineSegments, MeshBasicMaterial, MeshStandardMaterial } from "three";
import { degToRad } from "three/src/math/MathUtils";
import { useSpring, animated as a, config as springConfig } from "@react-spring/three";

import RoundedQuadGeometry from "./RoundedQuadGeometry";
import { createPodestMaterial } from "./Materials";
import { useSnapshot } from "valtio";
import store from "../../appStore";

const RoundedPodest = ({ lenght = 2, width = 1, height = 0.25, glow = false, ...props }) => {
  const [line, setLine] = useState();

  const geometryRef = useRef();

  // const edgeGeo = useMemo(() => {
  //   if (geometryRef.current) {
  //     console.log(geometryRef.current);
  //   }
  // }, [geometryRef]);
  const lineMaterial = useMemo(() => {
    return new MeshBasicMaterial({
      color: new Color(102, 204, 153).multiplyScalar(0.015),
      transparent: true,
      opacity: 0.0,
      depthWrite: false,
      toneMapped: false,
    });
  }, []);

  const { faded } = useSnapshot(store);

  useLayoutEffect(() => {
    const edges = new EdgesGeometry(geometryRef.current, 10);
    const line = new LineSegments(edges, lineMaterial);

    setLine(line);
  }, [lineMaterial]);

  const spring = useSpring({
    opacity: glow ? (faded ? 0 : 1) : 0,
    onChange: ({ value }) => {
      lineMaterial.opacity = value.opacity;
    },
    config: { clamp: true, ...springConfig.default },
  });

  const podestMaterial = useMemo(() => {
    return createPodestMaterial();
  }, []);

  return (
    <group {...props}>
      <mesh position={[0, height / 2, 0]} rotation={[degToRad(90), 0, 0]} material={podestMaterial}>
        <RoundedQuadGeometry lenght={lenght} width={width} height={height} radius={0.05} curveSegments={5} ref={geometryRef} />
      </mesh>
      {line && <primitive object={line} position={[0, height / 2, 0]} rotation={[degToRad(90), 0, 0]} renderOrder={1} />}
    </group>
  );
};

export default RoundedPodest;
